<template>
  <v-container>
    <h1 class="mt-3">Contact us</h1>
    <v-divider class="mt-2 mb-5"></v-divider>
    <div class="contactInfo mt-2">Questions about Sonive Publishing? Reach out to us at</div>
    <div class="mt-1" id="email">contactus@sonive.com</div>
    <div class="contactInfo mt-5">Business inquiries (wholesale, etc.) can be sent to</div>
    <div class="mt-1" id="email">business@sonive.com</div>
  </v-container>
</template>

<script>

export default {
  name: "Contact",
  components:{
  },
  head: {
    title: {
      inner: "Sonive Publishing",
      separator: "-",
      complement: "Contact us"
    },
    meta: [
      {
        name: "description",
        content: "Reach out to us with questions and business inquiries."
      }
    ]
  },
  data: () => ({})
};
</script>

<style>
.contactInfo{
  font-size: 20px;
}

#email{
  font-weight: 700;
  font-size: 28px;
}
</style>